import { Container } from '@/components';
import { ROUTES, RouteName } from '@/constants';
import { useGlobalState, useResponsive } from '@/hooks';
import { /*ButtonSize,*/ type IHeader, ResponsiveCollection } from '@/interfaces';
import { getPmtLangHref, /*gtmClickHeaderSignups,*/ gtmClickPmc } from '@/utils';
import Image from 'next/image';
import Link from 'next/link';
import type React from 'react';
import CollapseNavigation from './CollapseNavigation';
import DropdownNavigation from './DropdownNavigation';
import {
  ExploreCommunityButton,
  ExploreCommunityLink,
  HeaderContent,
  HeaderWrapper,
  // LogInButton,
  Logo,
  ParcelMonitorLogo,
  ProfileGroup,
} from './Header.styles';
import Languages from './Languages';
import Profile from './Profile';

const Header: React.FC<IHeader & { onlyLogo?: boolean }> = (props) => {
  const { itemList, button, onlyLogo } = props;

  const { isDesktopPMT, isTablet } = useResponsive([ResponsiveCollection.DesktopPMT, ResponsiveCollection.Tablet]);

  const {
    pmtCurrentLanguageCode,
    /*setIsFromJoinUsBtn,*/ /*isLoggedIn,*/ /*isHomepage,*/ isMultiLanguagePage /*isErrorPage,*/ /*isSeoPage*/,
  } = useGlobalState();
  // const { isDesktop } = useResponsive([ResponsiveCollection.Desktop]);

  const DEFAULT_BUTTON_TEXT = 'EXPLORE THE COMMUNITY';

  const TrackingHeader = (
    <>
      <a href={getPmtLangHref(pmtCurrentLanguageCode)}>
        <ParcelMonitorLogo />
      </a>
      {isDesktopPMT ? (
        <>
          <Languages />
          <ProfileGroup>
            <Profile />
            <ExploreCommunityLink href='/' target='_blank' onClick={() => gtmClickPmc('/')}>
              <ExploreCommunityButton truncate isPMTButton>
                {button || DEFAULT_BUTTON_TEXT}
              </ExploreCommunityButton>
            </ExploreCommunityLink>
          </ProfileGroup>
        </>
      ) : (
        <ProfileGroup>
          <Profile />
          <CollapseNavigation {...props} />
        </ProfileGroup>
      )}
    </>
  );

  // // For handling JOIN US button click
  // const handleJoinUsButtonClick = () => {
  //   setIsFromJoinUsBtn(true);
  //   gtmClickHeaderSignups();
  // };

  const CommunityHeader = (
    <>
      <Link href={ROUTES[RouteName.Home].path ?? '#'} passHref>
        <Logo>
          <Image src='/images/icons/monitor_logo.svg' alt='Parcel Monitor Logo' fill sizes='100vw' />
        </Logo>
      </Link>
      {!onlyLogo && (
        <>
          {!isTablet && <DropdownNavigation itemList={itemList} />}
          <ProfileGroup>
            <Profile />
            {/* {!isLoggedIn && isDesktop && !isHomepage && !isErrorPage && !isSeoPage && (
              <LogInButton size={ButtonSize.Medium} onClick={handleJoinUsButtonClick}>
                JOIN US
              </LogInButton>
            )} */}
            {isTablet && <CollapseNavigation itemList={itemList} />}
          </ProfileGroup>
        </>
      )}
    </>
  );

  return (
    <HeaderWrapper id='header'>
      <Container>
        <HeaderContent>{isMultiLanguagePage ? TrackingHeader : CommunityHeader}</HeaderContent>
      </Container>
    </HeaderWrapper>
  );
};

export default Header;
